import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
} from '@/components/ui/dialog'
import { useAuthStore } from '@/features/auth/authStore'

interface ExportHistoryDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const ExportHistoryDialog: React.FC<ExportHistoryDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()
  const user = useAuthStore((state) => state.user)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogContent className="sm:max-w-[480px] bg-white shadow-xl rounded-2xl p-6">
          <DialogHeader className="space-y-0.5">
            <DialogTitle className="m-0 font-semibold text-xl text-primary-900">
              {t('history.exportDialog.title')}
            </DialogTitle>
            <DialogDescription className="text-md text-tertiary-600 pt-2">
              {t('history.exportDialog.description')}{' '}
              <span className="font-semibold text-primary-900">
                {user?.email || '[user email]'}
              </span>
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="flex sm:justify-end !space-x-0 gap-lg pt-3 flex-shrink-0">
            <Button
              type="button"
              className="w-auto rounded-md py-2.5 px-xl font-semibold text-sm border-solid border-transparent !text-white !bg-brand-600 hover:!bg-brand-700"
              variant="default"
              onClick={() => onOpenChange(false)}
            >
              {t('history.exportDialog.ok')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}

export default ExportHistoryDialog
